import * as React from 'react';
import { DynamicForm } from '../../../components/FormComponents/dynamicForm';
import { createInitialFormValues } from '../../../components/FormComponents/dynamicForm/form_validation';
var WizardStepForm = React.forwardRef(function (_a, ref) {
    var sections = _a.sections, payloadKey = _a.payloadKey, previewLabel = _a.previewLabel;
    var formRef = React.useRef(null);
    var initialValues = React.useMemo(function () { return createInitialFormValues(sections); }, [sections]);
    React.useImperativeHandle(ref, function () { return ({
        validate: function () { var _a, _b; return (_b = (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.validate()) !== null && _b !== void 0 ? _b : true; },
        getPayload: function () {
            var _a;
            var _b, _c;
            return (_a = {}, _a[payloadKey] = (_c = (_b = formRef.current) === null || _b === void 0 ? void 0 : _b.getValues()) !== null && _c !== void 0 ? _c : {}, _a);
        },
        getFiles: function () { var _a, _b; return (_b = (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.getFiles()) !== null && _b !== void 0 ? _b : {}; },
        reset: function () { var _a; return (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.reset(); },
        getPreview: function () {
            var _a, _b;
            return ({
                label: previewLabel,
                records: [{ sections: sections, values: (_b = (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.getValues()) !== null && _b !== void 0 ? _b : {} }],
            });
        },
    }); }, [payloadKey, previewLabel, sections]);
    return React.createElement(DynamicForm, { ref: formRef, sections: sections, initialValues: initialValues });
});
WizardStepForm.displayName = 'WizardStepForm';
export default WizardStepForm;
